package flagpack.icons.small

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * San Marino Flag (16x12dp)
 *
 * - ISO Alpha-2: SM
 * - ISO Alpha-3: SMR
 * - ISO Numeric: 674
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Small.SanMarino: ImageVector by lazy {
    ImageVector.Builder(
        name = "San Marino:SM:SMR:674:Small",
        defaultWidth = 16.dp,
        defaultHeight = 12.dp,
        viewportWidth = 16f,
        viewportHeight = 12f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(16f)
                verticalLineToRelative(12f)
                horizontalLineToRelative(-16f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(16f)
                verticalLineToRelative(12f)
                horizontalLineToRelative(-16f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(12f)
                horizontalLineTo(16f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                verticalLineTo(12f)
                horizontalLineTo(16f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        ) {
            path(
                fill = SolidColor(Color(0xFF56C6F5)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 6f)
                verticalLineTo(12f)
                horizontalLineTo(16f)
                verticalLineTo(6f)
                horizontalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF006923)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(5.127f, 4.514f)
                curveTo(5.123f, 4.472f, 5.115f, 4.435f, 5.099f, 4.407f)
                curveTo(4.971f, 4.168f, 5.012f, 3.868f, 5.012f, 3.868f)
                curveTo(5.012f, 3.868f, 4.859f, 4.219f, 4.769f, 4.549f)
                curveTo(4.674f, 4.395f, 4.641f, 4.241f, 4.641f, 4.241f)
                curveTo(4.641f, 4.241f, 4.58f, 5.21f, 4.767f, 5.44f)
                curveTo(4.954f, 5.669f, 5.079f, 5.77f, 5.079f, 5.77f)
                curveTo(5.079f, 5.77f, 5.093f, 5.368f, 5.039f, 5.053f)
                curveTo(5.077f, 4.922f, 5.112f, 4.778f, 5.124f, 4.654f)
                curveTo(5.149f, 4.636f, 5.214f, 4.587f, 5.295f, 4.521f)
                curveTo(5.261f, 4.71f, 5.259f, 4.812f, 5.259f, 4.812f)
                curveTo(5.259f, 4.812f, 5.964f, 4.3f, 5.982f, 4.029f)
                curveTo(6f, 3.758f, 6.194f, 3.526f, 6.194f, 3.526f)
                curveTo(6.194f, 3.526f, 6.034f, 3.636f, 5.85f, 3.783f)
                curveTo(5.899f, 3.555f, 6.049f, 3.376f, 6.049f, 3.376f)
                curveTo(6.049f, 3.376f, 5.248f, 3.924f, 5.182f, 4.213f)
                curveTo(5.153f, 4.338f, 5.137f, 4.44f, 5.127f, 4.514f)
                close()
                moveTo(5.161f, 6.179f)
                curveTo(5.085f, 6.034f, 4.75f, 5.426f, 4.517f, 5.374f)
                curveTo(4.252f, 5.313f, 4.053f, 5.086f, 4.053f, 5.086f)
                curveTo(4.053f, 5.086f, 4.47f, 5.963f, 4.745f, 6.073f)
                curveTo(4.965f, 6.161f, 5.111f, 6.196f, 5.159f, 6.207f)
                curveTo(5.151f, 6.325f, 5.15f, 6.407f, 5.15f, 6.407f)
                curveTo(5.15f, 6.407f, 5.28f, 6.312f, 5.479f, 6.093f)
                curveTo(5.678f, 5.874f, 5.667f, 4.903f, 5.667f, 4.903f)
                curveTo(5.667f, 4.903f, 5.589f, 5.195f, 5.377f, 5.365f)
                curveTo(5.235f, 5.479f, 5.181f, 5.909f, 5.161f, 6.179f)
                close()
                moveTo(4.536f, 6.088f)
                curveTo(4.838f, 6.086f, 5.304f, 6.828f, 5.304f, 6.828f)
                curveTo(5.304f, 6.828f, 5.124f, 6.838f, 4.808f, 6.788f)
                curveTo(4.493f, 6.738f, 4.002f, 5.893f, 4.002f, 5.893f)
                curveTo(4.002f, 5.893f, 4.233f, 6.089f, 4.536f, 6.088f)
                close()
                moveTo(6.011f, 7.816f)
                curveTo(6.011f, 7.816f, 6.191f, 6.87f, 5.921f, 6.65f)
                curveTo(5.651f, 6.429f, 5.604f, 6.1f, 5.604f, 6.1f)
                curveTo(5.604f, 6.1f, 5.364f, 7.149f, 5.604f, 7.42f)
                curveTo(5.843f, 7.692f, 6.011f, 7.816f, 6.011f, 7.816f)
                close()
                moveTo(4.923f, 7.561f)
                curveTo(5.099f, 7.77f, 5.66f, 7.561f, 5.66f, 7.561f)
                curveTo(5.66f, 7.561f, 5.784f, 7.673f, 5.339f, 7.266f)
                curveTo(4.894f, 6.86f, 3.988f, 7.117f, 4.232f, 7.117f)
                curveTo(4.476f, 7.117f, 4.747f, 7.352f, 4.923f, 7.561f)
                close()
                moveTo(5.339f, 8.671f)
                curveTo(5.665f, 8.947f, 6.371f, 8.29f, 6.371f, 8.29f)
                curveTo(6.371f, 8.29f, 6.189f, 8.07f, 5.852f, 7.908f)
                curveTo(5.516f, 7.746f, 4.274f, 7.908f, 4.274f, 7.908f)
                lineTo(4.827f, 8.154f)
                curveTo(4.827f, 8.154f, 4.212f, 8.394f, 4.375f, 8.381f)
                curveTo(4.538f, 8.368f, 5.012f, 8.394f, 5.339f, 8.671f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF009933)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(9.607f, 8.098f)
                curveTo(9.607f, 8.098f, 9.326f, 7.626f, 9.607f, 7.399f)
                curveTo(9.887f, 7.171f, 9.999f, 7.322f, 9.999f, 7.06f)
                curveTo(9.999f, 6.798f, 10.027f, 6.876f, 10.165f, 6.746f)
                curveTo(10.303f, 6.616f, 10.205f, 6.3f, 10.39f, 6.458f)
                curveTo(10.575f, 6.616f, 10.609f, 6.313f, 10.609f, 6.943f)
                curveTo(10.609f, 7.572f, 10.609f, 6.372f, 10.609f, 6.018f)
                curveTo(10.609f, 5.665f, 10.39f, 5.749f, 10.39f, 5.512f)
                curveTo(10.39f, 5.275f, 10.171f, 4.921f, 10.39f, 4.921f)
                curveTo(10.609f, 4.921f, 10.738f, 5.184f, 10.738f, 5.184f)
                curveTo(10.738f, 5.184f, 10.953f, 5.551f, 10.953f, 5.184f)
                curveTo(10.953f, 4.817f, 10.57f, 4.926f, 10.39f, 4.521f)
                curveTo(10.21f, 4.116f, 10.238f, 4.566f, 9.999f, 4.044f)
                curveTo(9.759f, 3.523f, 9.473f, 3.357f, 9.736f, 3.357f)
                curveTo(9.999f, 3.357f, 9.94f, 3.357f, 10.165f, 3.357f)
                curveTo(10.39f, 3.357f, 10.738f, 3.17f, 10.738f, 3.357f)
                curveTo(10.738f, 3.544f, 10.738f, 3.458f, 10.738f, 3.751f)
                curveTo(10.738f, 4.044f, 10.953f, 4.044f, 10.953f, 4.044f)
                curveTo(10.953f, 4.044f, 11.07f, 3.458f, 11.217f, 3.751f)
                curveTo(11.364f, 4.044f, 11.264f, 4.521f, 11.372f, 4.521f)
                curveTo(11.48f, 4.521f, 11.391f, 4.029f, 11.625f, 4.406f)
                curveTo(11.861f, 4.783f, 11.625f, 5.039f, 11.625f, 5.184f)
                curveTo(11.625f, 5.33f, 11.372f, 5.686f, 11.372f, 5.686f)
                curveTo(11.372f, 5.686f, 11.421f, 5.86f, 11.625f, 5.686f)
                curveTo(11.83f, 5.512f, 12.023f, 5.337f, 12.023f, 5.512f)
                curveTo(12.023f, 5.686f, 12.421f, 5.74f, 12.023f, 6.018f)
                curveTo(11.625f, 6.297f, 11.879f, 6.575f, 11.625f, 6.575f)
                curveTo(11.372f, 6.575f, 11.073f, 6.943f, 10.953f, 6.943f)
                curveTo(10.833f, 6.943f, 10.385f, 7.224f, 10.609f, 7.224f)
                curveTo(10.833f, 7.224f, 11.063f, 6.661f, 11.217f, 6.943f)
                curveTo(11.372f, 7.224f, 11.37f, 6.897f, 11.498f, 7.06f)
                curveTo(11.625f, 7.224f, 11.753f, 8.111f, 11.625f, 7.755f)
                curveTo(11.498f, 7.399f, 11.297f, 7.399f, 10.953f, 7.399f)
                curveTo(10.609f, 7.399f, 9.94f, 7.424f, 10.165f, 7.589f)
                curveTo(10.39f, 7.755f, 10.642f, 7.424f, 10.738f, 7.589f)
                curveTo(10.833f, 7.755f, 10.806f, 7.92f, 10.953f, 7.755f)
                curveTo(11.101f, 7.589f, 11.246f, 7.755f, 11.372f, 7.755f)
                curveTo(11.498f, 7.755f, 11.246f, 7.939f, 11.372f, 8.098f)
                curveTo(11.498f, 8.257f, 11.778f, 8.468f, 11.498f, 8.468f)
                curveTo(11.217f, 8.468f, 11.073f, 8.244f, 10.953f, 8.468f)
                curveTo(10.833f, 8.692f, 10.828f, 9.082f, 10.609f, 8.775f)
                curveTo(10.39f, 8.468f, 9.999f, 8.624f, 9.999f, 8.468f)
                curveTo(9.999f, 8.313f, 10.084f, 8.287f, 9.845f, 8.287f)
                curveTo(9.607f, 8.287f, 9.607f, 8.098f, 9.607f, 8.098f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFC51918)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(10.758f, 4.725f)
                curveTo(10.758f, 4.794f, 10.704f, 4.85f, 10.637f, 4.85f)
                curveTo(10.57f, 4.85f, 10.516f, 4.794f, 10.516f, 4.725f)
                curveTo(10.516f, 4.656f, 10.57f, 4.6f, 10.637f, 4.6f)
                curveTo(10.704f, 4.6f, 10.758f, 4.656f, 10.758f, 4.725f)
                close()
                moveTo(5.169f, 5f)
                curveTo(5.236f, 5f, 5.29f, 4.944f, 5.29f, 4.875f)
                curveTo(5.29f, 4.806f, 5.236f, 4.75f, 5.169f, 4.75f)
                curveTo(5.103f, 4.75f, 5.048f, 4.806f, 5.048f, 4.875f)
                curveTo(5.048f, 4.944f, 5.103f, 5f, 5.169f, 5f)
                close()
                moveTo(5.29f, 5.525f)
                curveTo(5.29f, 5.594f, 5.236f, 5.65f, 5.169f, 5.65f)
                curveTo(5.103f, 5.65f, 5.048f, 5.594f, 5.048f, 5.525f)
                curveTo(5.048f, 5.456f, 5.103f, 5.4f, 5.169f, 5.4f)
                curveTo(5.236f, 5.4f, 5.29f, 5.456f, 5.29f, 5.525f)
                close()
                moveTo(5.363f, 6.8f)
                curveTo(5.43f, 6.8f, 5.484f, 6.744f, 5.484f, 6.675f)
                curveTo(5.484f, 6.606f, 5.43f, 6.55f, 5.363f, 6.55f)
                curveTo(5.296f, 6.55f, 5.242f, 6.606f, 5.242f, 6.675f)
                curveTo(5.242f, 6.744f, 5.296f, 6.8f, 5.363f, 6.8f)
                close()
                moveTo(6.331f, 8.05f)
                curveTo(6.398f, 8.05f, 6.452f, 7.994f, 6.452f, 7.925f)
                curveTo(6.452f, 7.856f, 6.398f, 7.8f, 6.331f, 7.8f)
                curveTo(6.264f, 7.8f, 6.21f, 7.856f, 6.21f, 7.925f)
                curveTo(6.21f, 7.994f, 6.264f, 8.05f, 6.331f, 8.05f)
                close()
                moveTo(10.976f, 6.15f)
                curveTo(11.043f, 6.15f, 11.097f, 6.094f, 11.097f, 6.025f)
                curveTo(11.097f, 5.956f, 11.043f, 5.9f, 10.976f, 5.9f)
                curveTo(10.909f, 5.9f, 10.855f, 5.956f, 10.855f, 6.025f)
                curveTo(10.855f, 6.094f, 10.909f, 6.15f, 10.976f, 6.15f)
                close()
                moveTo(10.71f, 7.025f)
                curveTo(10.71f, 7.094f, 10.656f, 7.15f, 10.589f, 7.15f)
                curveTo(10.522f, 7.15f, 10.468f, 7.094f, 10.468f, 7.025f)
                curveTo(10.468f, 6.956f, 10.522f, 6.9f, 10.589f, 6.9f)
                curveTo(10.656f, 6.9f, 10.71f, 6.956f, 10.71f, 7.025f)
                close()
                moveTo(9.573f, 8.25f)
                curveTo(9.639f, 8.25f, 9.694f, 8.194f, 9.694f, 8.125f)
                curveTo(9.694f, 8.056f, 9.639f, 8f, 9.573f, 8f)
                curveTo(9.506f, 8f, 9.452f, 8.056f, 9.452f, 8.125f)
                curveTo(9.452f, 8.194f, 9.506f, 8.25f, 9.573f, 8.25f)
                close()
                moveTo(6.5f, 8.275f)
                curveTo(6.5f, 8.344f, 6.446f, 8.4f, 6.379f, 8.4f)
                curveTo(6.312f, 8.4f, 6.258f, 8.344f, 6.258f, 8.275f)
                curveTo(6.258f, 8.206f, 6.312f, 8.15f, 6.379f, 8.15f)
                curveTo(6.446f, 8.15f, 6.5f, 8.206f, 6.5f, 8.275f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFECA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(9.019f, 9.91f)
                curveTo(9.019f, 9.807f, 7.469f, 8.739f, 7.053f, 8.503f)
                curveTo(6.636f, 8.268f, 4.605f, 6.971f, 5.158f, 5f)
                horizontalLineTo(5.074f)
                curveTo(5.074f, 5f, 4.7f, 7.428f, 7.28f, 8.938f)
                curveTo(8.454f, 9.726f, 8.513f, 9.91f, 8.513f, 9.91f)
                curveTo(8.513f, 9.91f, 9.019f, 10.012f, 9.019f, 9.91f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFECA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(6.962f, 9.91f)
                curveTo(6.962f, 9.807f, 8.513f, 8.739f, 8.929f, 8.503f)
                curveTo(9.345f, 8.268f, 11.377f, 6.971f, 10.823f, 5f)
                horizontalLineTo(10.907f)
                curveTo(10.907f, 5f, 11.281f, 7.428f, 8.701f, 8.938f)
                curveTo(7.527f, 9.726f, 7.468f, 9.91f, 7.468f, 9.91f)
                curveTo(7.468f, 9.91f, 6.962f, 10.012f, 6.962f, 9.91f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF56C6F5)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(8.024f, 8.443f)
                curveTo(9.107f, 8.443f, 9.984f, 7.042f, 9.984f, 5.675f)
                curveTo(9.984f, 4.308f, 9.107f, 3.6f, 8.024f, 3.6f)
                curveTo(6.942f, 3.6f, 6.065f, 4.308f, 6.065f, 5.675f)
                curveTo(6.065f, 7.042f, 6.942f, 8.443f, 8.024f, 8.443f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(7.157f, 4.769f)
                curveTo(7.157f, 4.769f, 7.458f, 4.503f, 7.308f, 4.503f)
                curveTo(7.278f, 4.503f, 7.243f, 4.498f, 7.204f, 4.491f)
                curveTo(7.045f, 4.466f, 6.837f, 4.432f, 6.837f, 4.769f)
                verticalLineTo(5.349f)
                lineTo(6.837f, 5.35f)
                horizontalLineTo(6.792f)
                curveTo(6.764f, 5.35f, 6.742f, 5.372f, 6.742f, 5.4f)
                curveTo(6.742f, 5.428f, 6.764f, 5.45f, 6.792f, 5.45f)
                horizontalLineTo(6.831f)
                curveTo(6.824f, 5.574f, 6.813f, 5.794f, 6.801f, 6.014f)
                lineTo(6.744f, 6.019f)
                curveTo(6.714f, 6.021f, 6.692f, 6.047f, 6.695f, 6.077f)
                lineTo(6.699f, 6.119f)
                curveTo(6.701f, 6.149f, 6.727f, 6.171f, 6.757f, 6.168f)
                lineTo(6.793f, 6.165f)
                curveTo(6.78f, 6.422f, 6.768f, 6.647f, 6.768f, 6.674f)
                curveTo(6.768f, 6.742f, 7.227f, 6.716f, 7.227f, 6.716f)
                curveTo(7.227f, 6.716f, 7.213f, 6.445f, 7.197f, 6.13f)
                lineTo(7.228f, 6.127f)
                curveTo(7.258f, 6.124f, 7.28f, 6.098f, 7.277f, 6.069f)
                lineTo(7.273f, 6.026f)
                curveTo(7.271f, 5.997f, 7.245f, 5.975f, 7.215f, 5.977f)
                lineTo(7.19f, 5.98f)
                curveTo(7.181f, 5.791f, 7.172f, 5.599f, 7.165f, 5.45f)
                horizontalLineTo(7.224f)
                curveTo(7.252f, 5.45f, 7.274f, 5.428f, 7.274f, 5.4f)
                curveTo(7.274f, 5.372f, 7.252f, 5.35f, 7.224f, 5.35f)
                horizontalLineTo(7.161f)
                curveTo(7.158f, 5.275f, 7.157f, 5.219f, 7.157f, 5.191f)
                verticalLineTo(4.769f)
                close()
            }
            path(
                fill = SolidColor(Color.Black),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(6.936f, 5.5f)
                horizontalLineTo(7.097f)
                verticalLineTo(5.715f)
                horizontalLineTo(6.936f)
                verticalLineTo(5.5f)
                close()
            }
            path(
                fill = SolidColor(Color.Black),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(6.887f, 6.25f)
                horizontalLineTo(7.156f)
                verticalLineTo(6.75f)
                horizontalLineTo(6.887f)
                verticalLineTo(6.25f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(8.173f, 4.769f)
                curveTo(8.173f, 4.769f, 8.475f, 4.503f, 8.324f, 4.503f)
                curveTo(8.294f, 4.503f, 8.259f, 4.498f, 8.22f, 4.491f)
                curveTo(8.061f, 4.466f, 7.853f, 4.432f, 7.853f, 4.769f)
                verticalLineTo(5.349f)
                lineTo(7.853f, 5.35f)
                horizontalLineTo(7.808f)
                curveTo(7.781f, 5.35f, 7.758f, 5.372f, 7.758f, 5.4f)
                curveTo(7.758f, 5.428f, 7.781f, 5.45f, 7.808f, 5.45f)
                horizontalLineTo(7.847f)
                curveTo(7.841f, 5.574f, 7.829f, 5.794f, 7.817f, 6.014f)
                lineTo(7.76f, 6.019f)
                curveTo(7.73f, 6.021f, 7.708f, 6.047f, 7.711f, 6.077f)
                lineTo(7.715f, 6.119f)
                curveTo(7.717f, 6.149f, 7.743f, 6.171f, 7.773f, 6.168f)
                lineTo(7.809f, 6.165f)
                curveTo(7.796f, 6.422f, 7.784f, 6.647f, 7.784f, 6.674f)
                curveTo(7.784f, 6.742f, 8.244f, 6.716f, 8.244f, 6.716f)
                curveTo(8.244f, 6.716f, 8.229f, 6.445f, 8.214f, 6.13f)
                lineTo(8.244f, 6.127f)
                curveTo(8.274f, 6.124f, 8.296f, 6.098f, 8.293f, 6.069f)
                lineTo(8.289f, 6.026f)
                curveTo(8.287f, 5.997f, 8.261f, 5.975f, 8.231f, 5.977f)
                lineTo(8.206f, 5.98f)
                curveTo(8.197f, 5.791f, 8.188f, 5.599f, 8.181f, 5.45f)
                horizontalLineTo(8.24f)
                curveTo(8.268f, 5.45f, 8.29f, 5.428f, 8.29f, 5.4f)
                curveTo(8.29f, 5.372f, 8.268f, 5.35f, 8.24f, 5.35f)
                horizontalLineTo(8.177f)
                curveTo(8.175f, 5.275f, 8.173f, 5.219f, 8.173f, 5.191f)
                verticalLineTo(4.769f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(9.141f, 4.769f)
                curveTo(9.141f, 4.769f, 9.442f, 4.503f, 9.291f, 4.503f)
                curveTo(9.262f, 4.503f, 9.227f, 4.498f, 9.188f, 4.491f)
                curveTo(9.028f, 4.466f, 8.821f, 4.432f, 8.821f, 4.769f)
                verticalLineTo(5.349f)
                lineTo(8.82f, 5.35f)
                horizontalLineTo(8.776f)
                curveTo(8.748f, 5.35f, 8.726f, 5.372f, 8.726f, 5.4f)
                curveTo(8.726f, 5.428f, 8.748f, 5.45f, 8.776f, 5.45f)
                horizontalLineTo(8.815f)
                curveTo(8.808f, 5.574f, 8.797f, 5.794f, 8.785f, 6.014f)
                lineTo(8.728f, 6.019f)
                curveTo(8.698f, 6.021f, 8.676f, 6.047f, 8.679f, 6.077f)
                lineTo(8.682f, 6.119f)
                curveTo(8.685f, 6.149f, 8.711f, 6.171f, 8.741f, 6.168f)
                lineTo(8.777f, 6.165f)
                curveTo(8.764f, 6.422f, 8.752f, 6.647f, 8.752f, 6.674f)
                curveTo(8.752f, 6.742f, 9.211f, 6.716f, 9.211f, 6.716f)
                curveTo(9.211f, 6.716f, 9.197f, 6.445f, 9.181f, 6.13f)
                lineTo(9.212f, 6.127f)
                curveTo(9.242f, 6.124f, 9.264f, 6.098f, 9.261f, 6.069f)
                lineTo(9.257f, 6.026f)
                curveTo(9.255f, 5.997f, 9.229f, 5.975f, 9.199f, 5.977f)
                lineTo(9.174f, 5.98f)
                curveTo(9.165f, 5.791f, 9.156f, 5.599f, 9.149f, 5.45f)
                horizontalLineTo(9.208f)
                curveTo(9.236f, 5.45f, 9.258f, 5.428f, 9.258f, 5.4f)
                curveTo(9.258f, 5.372f, 9.236f, 5.35f, 9.208f, 5.35f)
                horizontalLineTo(9.145f)
                curveTo(9.142f, 5.275f, 9.141f, 5.219f, 9.141f, 5.191f)
                verticalLineTo(4.769f)
                close()
            }
            path(
                fill = SolidColor(Color.Black),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(8.919f, 5.5f)
                horizontalLineTo(9.081f)
                verticalLineTo(5.715f)
                horizontalLineTo(8.919f)
                verticalLineTo(5.5f)
                close()
            }
            path(
                fill = SolidColor(Color.Black),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(8.871f, 6.25f)
                horizontalLineTo(9.14f)
                verticalLineTo(6.75f)
                horizontalLineTo(8.871f)
                verticalLineTo(6.25f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFE8AA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(9.258f, 3.2f)
                horizontalLineTo(6.694f)
                verticalLineTo(3.583f)
                lineTo(6.676f, 3.584f)
                curveTo(6.676f, 3.584f, 5.42f, 4.561f, 5.769f, 6.023f)
                curveTo(6.117f, 7.486f, 7.502f, 8.571f, 7.502f, 8.571f)
                lineTo(7.572f, 8.318f)
                curveTo(7.572f, 8.318f, 6.252f, 6.524f, 6.252f, 5.806f)
                curveTo(6.252f, 5.089f, 6.501f, 4.416f, 6.765f, 4.312f)
                curveTo(6.924f, 4.249f, 6.951f, 4.261f, 6.994f, 4.282f)
                curveTo(7.023f, 4.295f, 7.058f, 4.312f, 7.144f, 4.312f)
                curveTo(7.358f, 4.312f, 7.572f, 4.158f, 7.572f, 4.158f)
                curveTo(7.572f, 4.158f, 7.721f, 4.312f, 7.86f, 4.312f)
                curveTo(7.998f, 4.312f, 8f, 4.158f, 8f, 4.158f)
                verticalLineTo(3.65f)
                horizontalLineTo(8.016f)
                verticalLineTo(4.158f)
                curveTo(8.016f, 4.158f, 8.017f, 4.312f, 8.156f, 4.312f)
                curveTo(8.294f, 4.312f, 8.443f, 4.158f, 8.443f, 4.158f)
                curveTo(8.443f, 4.158f, 8.658f, 4.312f, 8.872f, 4.312f)
                curveTo(8.957f, 4.312f, 8.993f, 4.295f, 9.021f, 4.282f)
                curveTo(9.064f, 4.261f, 9.092f, 4.249f, 9.25f, 4.312f)
                curveTo(9.514f, 4.416f, 9.763f, 5.089f, 9.763f, 5.806f)
                curveTo(9.763f, 6.524f, 8.443f, 8.318f, 8.443f, 8.318f)
                lineTo(8.513f, 8.571f)
                curveTo(8.513f, 8.571f, 9.898f, 7.486f, 10.247f, 6.023f)
                curveTo(10.595f, 4.561f, 9.339f, 3.584f, 9.339f, 3.584f)
                lineTo(9.258f, 3.577f)
                verticalLineTo(3.2f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFFD018))) {
                moveTo(6.694f, 3.2f)
                verticalLineTo(2.95f)
                horizontalLineTo(6.444f)
                verticalLineTo(3.2f)
                horizontalLineTo(6.694f)
                close()
                moveTo(9.258f, 3.2f)
                horizontalLineTo(9.508f)
                verticalLineTo(2.95f)
                horizontalLineTo(9.258f)
                verticalLineTo(3.2f)
                close()
                moveTo(6.694f, 3.583f)
                lineTo(6.716f, 3.832f)
                lineTo(6.944f, 3.811f)
                verticalLineTo(3.583f)
                horizontalLineTo(6.694f)
                close()
                moveTo(6.676f, 3.584f)
                lineTo(6.654f, 3.335f)
                lineTo(6.581f, 3.342f)
                lineTo(6.523f, 3.387f)
                lineTo(6.676f, 3.584f)
                close()
                moveTo(5.769f, 6.023f)
                lineTo(5.525f, 6.081f)
                lineTo(5.769f, 6.023f)
                close()
                moveTo(7.502f, 8.571f)
                lineTo(7.348f, 8.767f)
                lineTo(7.643f, 8.998f)
                lineTo(7.743f, 8.637f)
                lineTo(7.502f, 8.571f)
                close()
                moveTo(7.572f, 8.318f)
                lineTo(7.813f, 8.385f)
                lineTo(7.846f, 8.268f)
                lineTo(7.774f, 8.17f)
                lineTo(7.572f, 8.318f)
                close()
                moveTo(6.765f, 4.312f)
                lineTo(6.673f, 4.079f)
                lineTo(6.673f, 4.079f)
                lineTo(6.765f, 4.312f)
                close()
                moveTo(6.994f, 4.282f)
                lineTo(6.888f, 4.508f)
                lineTo(6.888f, 4.508f)
                lineTo(6.994f, 4.282f)
                close()
                moveTo(7.572f, 4.158f)
                lineTo(7.752f, 3.984f)
                lineTo(7.602f, 3.83f)
                lineTo(7.427f, 3.955f)
                lineTo(7.572f, 4.158f)
                close()
                moveTo(8f, 4.158f)
                lineTo(8.25f, 4.162f)
                verticalLineTo(4.158f)
                horizontalLineTo(8f)
                close()
                moveTo(8f, 3.65f)
                verticalLineTo(3.4f)
                horizontalLineTo(7.75f)
                verticalLineTo(3.65f)
                horizontalLineTo(8f)
                close()
                moveTo(8.016f, 3.65f)
                horizontalLineTo(8.266f)
                verticalLineTo(3.4f)
                horizontalLineTo(8.016f)
                verticalLineTo(3.65f)
                close()
                moveTo(8.016f, 4.158f)
                horizontalLineTo(7.765f)
                lineTo(7.766f, 4.162f)
                lineTo(8.016f, 4.158f)
                close()
                moveTo(8.443f, 4.158f)
                lineTo(8.589f, 3.955f)
                lineTo(8.414f, 3.83f)
                lineTo(8.264f, 3.984f)
                lineTo(8.443f, 4.158f)
                close()
                moveTo(9.021f, 4.282f)
                lineTo(9.127f, 4.508f)
                lineTo(9.021f, 4.282f)
                close()
                moveTo(9.25f, 4.312f)
                lineTo(9.158f, 4.544f)
                lineTo(9.25f, 4.312f)
                close()
                moveTo(8.443f, 8.318f)
                lineTo(8.242f, 8.17f)
                lineTo(8.17f, 8.268f)
                lineTo(8.202f, 8.385f)
                lineTo(8.443f, 8.318f)
                close()
                moveTo(8.513f, 8.571f)
                lineTo(8.272f, 8.637f)
                lineTo(8.372f, 8.998f)
                lineTo(8.667f, 8.767f)
                lineTo(8.513f, 8.571f)
                close()
                moveTo(9.339f, 3.584f)
                lineTo(9.492f, 3.387f)
                lineTo(9.434f, 3.342f)
                lineTo(9.361f, 3.335f)
                lineTo(9.339f, 3.584f)
                close()
                moveTo(9.258f, 3.577f)
                horizontalLineTo(9.008f)
                verticalLineTo(3.806f)
                lineTo(9.236f, 3.826f)
                lineTo(9.258f, 3.577f)
                close()
                moveTo(6.694f, 3.45f)
                horizontalLineTo(9.258f)
                verticalLineTo(2.95f)
                horizontalLineTo(6.694f)
                verticalLineTo(3.45f)
                close()
                moveTo(6.944f, 3.583f)
                verticalLineTo(3.2f)
                horizontalLineTo(6.444f)
                verticalLineTo(3.583f)
                horizontalLineTo(6.944f)
                close()
                moveTo(6.699f, 3.833f)
                lineTo(6.716f, 3.832f)
                lineTo(6.671f, 3.334f)
                lineTo(6.654f, 3.335f)
                lineTo(6.699f, 3.833f)
                close()
                moveTo(6.012f, 5.965f)
                curveTo(5.858f, 5.32f, 6.056f, 4.779f, 6.303f, 4.389f)
                curveTo(6.427f, 4.194f, 6.561f, 4.04f, 6.664f, 3.935f)
                curveTo(6.715f, 3.883f, 6.758f, 3.843f, 6.788f, 3.817f)
                curveTo(6.803f, 3.804f, 6.814f, 3.795f, 6.821f, 3.789f)
                curveTo(6.825f, 3.786f, 6.827f, 3.784f, 6.829f, 3.782f)
                curveTo(6.83f, 3.782f, 6.83f, 3.782f, 6.83f, 3.781f)
                curveTo(6.83f, 3.781f, 6.83f, 3.781f, 6.83f, 3.781f)
                curveTo(6.83f, 3.781f, 6.83f, 3.781f, 6.83f, 3.782f)
                curveTo(6.83f, 3.782f, 6.83f, 3.782f, 6.83f, 3.782f)
                curveTo(6.83f, 3.782f, 6.83f, 3.782f, 6.676f, 3.584f)
                curveTo(6.523f, 3.387f, 6.523f, 3.387f, 6.523f, 3.387f)
                curveTo(6.523f, 3.387f, 6.523f, 3.387f, 6.523f, 3.387f)
                curveTo(6.522f, 3.387f, 6.522f, 3.387f, 6.522f, 3.388f)
                curveTo(6.522f, 3.388f, 6.521f, 3.388f, 6.521f, 3.389f)
                curveTo(6.52f, 3.389f, 6.518f, 3.391f, 6.517f, 3.392f)
                curveTo(6.513f, 3.395f, 6.509f, 3.398f, 6.503f, 3.403f)
                curveTo(6.492f, 3.412f, 6.477f, 3.425f, 6.458f, 3.441f)
                curveTo(6.42f, 3.474f, 6.368f, 3.522f, 6.307f, 3.585f)
                curveTo(6.186f, 3.708f, 6.027f, 3.89f, 5.881f, 4.122f)
                curveTo(5.587f, 4.585f, 5.331f, 5.264f, 5.525f, 6.081f)
                lineTo(6.012f, 5.965f)
                close()
                moveTo(7.502f, 8.571f)
                curveTo(7.657f, 8.374f, 7.657f, 8.374f, 7.657f, 8.374f)
                curveTo(7.657f, 8.374f, 7.657f, 8.374f, 7.657f, 8.374f)
                curveTo(7.657f, 8.374f, 7.657f, 8.374f, 7.657f, 8.374f)
                curveTo(7.657f, 8.374f, 7.657f, 8.374f, 7.656f, 8.374f)
                curveTo(7.656f, 8.373f, 7.655f, 8.373f, 7.654f, 8.372f)
                curveTo(7.652f, 8.37f, 7.649f, 8.368f, 7.644f, 8.364f)
                curveTo(7.635f, 8.356f, 7.621f, 8.345f, 7.603f, 8.33f)
                curveTo(7.567f, 8.3f, 7.515f, 8.254f, 7.45f, 8.194f)
                curveTo(7.32f, 8.075f, 7.143f, 7.901f, 6.956f, 7.682f)
                curveTo(6.578f, 7.243f, 6.173f, 6.642f, 6.012f, 5.965f)
                lineTo(5.525f, 6.081f)
                curveTo(5.713f, 6.868f, 6.175f, 7.54f, 6.577f, 8.008f)
                curveTo(6.779f, 8.244f, 6.97f, 8.432f, 7.111f, 8.562f)
                curveTo(7.182f, 8.627f, 7.24f, 8.678f, 7.281f, 8.712f)
                curveTo(7.302f, 8.729f, 7.318f, 8.743f, 7.329f, 8.752f)
                curveTo(7.335f, 8.757f, 7.339f, 8.76f, 7.343f, 8.763f)
                curveTo(7.344f, 8.764f, 7.346f, 8.765f, 7.346f, 8.766f)
                curveTo(7.347f, 8.766f, 7.347f, 8.767f, 7.348f, 8.767f)
                curveTo(7.348f, 8.767f, 7.348f, 8.767f, 7.348f, 8.767f)
                curveTo(7.348f, 8.767f, 7.348f, 8.767f, 7.348f, 8.767f)
                curveTo(7.348f, 8.767f, 7.348f, 8.767f, 7.502f, 8.571f)
                close()
                moveTo(7.331f, 8.251f)
                lineTo(7.261f, 8.504f)
                lineTo(7.743f, 8.637f)
                lineTo(7.813f, 8.385f)
                lineTo(7.331f, 8.251f)
                close()
                moveTo(6.002f, 5.806f)
                curveTo(6.002f, 6.044f, 6.107f, 6.334f, 6.232f, 6.606f)
                curveTo(6.361f, 6.888f, 6.532f, 7.189f, 6.699f, 7.462f)
                curveTo(6.867f, 7.736f, 7.035f, 7.987f, 7.16f, 8.168f)
                curveTo(7.223f, 8.259f, 7.275f, 8.334f, 7.312f, 8.385f)
                curveTo(7.331f, 8.411f, 7.345f, 8.431f, 7.355f, 8.445f)
                curveTo(7.36f, 8.452f, 7.364f, 8.457f, 7.367f, 8.46f)
                curveTo(7.368f, 8.462f, 7.369f, 8.464f, 7.37f, 8.465f)
                curveTo(7.37f, 8.465f, 7.37f, 8.465f, 7.371f, 8.466f)
                curveTo(7.371f, 8.466f, 7.371f, 8.466f, 7.371f, 8.466f)
                curveTo(7.371f, 8.466f, 7.371f, 8.466f, 7.371f, 8.466f)
                curveTo(7.371f, 8.466f, 7.371f, 8.466f, 7.572f, 8.318f)
                curveTo(7.774f, 8.17f, 7.774f, 8.17f, 7.774f, 8.17f)
                curveTo(7.774f, 8.17f, 7.774f, 8.17f, 7.774f, 8.17f)
                curveTo(7.774f, 8.17f, 7.774f, 8.17f, 7.774f, 8.17f)
                curveTo(7.773f, 8.17f, 7.773f, 8.169f, 7.773f, 8.169f)
                curveTo(7.772f, 8.168f, 7.772f, 8.167f, 7.77f, 8.165f)
                curveTo(7.768f, 8.162f, 7.764f, 8.157f, 7.76f, 8.151f)
                curveTo(7.75f, 8.138f, 7.737f, 8.119f, 7.719f, 8.094f)
                curveTo(7.684f, 8.045f, 7.633f, 7.973f, 7.572f, 7.885f)
                curveTo(7.45f, 7.708f, 7.287f, 7.465f, 7.126f, 7.201f)
                curveTo(6.963f, 6.935f, 6.804f, 6.653f, 6.686f, 6.397f)
                curveTo(6.563f, 6.13f, 6.502f, 5.927f, 6.502f, 5.806f)
                horizontalLineTo(6.002f)
                close()
                moveTo(6.673f, 4.079f)
                curveTo(6.54f, 4.132f, 6.439f, 4.241f, 6.367f, 4.348f)
                curveTo(6.291f, 4.46f, 6.227f, 4.597f, 6.174f, 4.747f)
                curveTo(6.069f, 5.046f, 6.002f, 5.421f, 6.002f, 5.806f)
                horizontalLineTo(6.502f)
                curveTo(6.502f, 5.475f, 6.56f, 5.155f, 6.646f, 4.912f)
                curveTo(6.689f, 4.791f, 6.736f, 4.695f, 6.781f, 4.629f)
                curveTo(6.829f, 4.558f, 6.859f, 4.543f, 6.857f, 4.544f)
                lineTo(6.673f, 4.079f)
                close()
                moveTo(7.1f, 4.055f)
                curveTo(7.07f, 4.041f, 7.004f, 4.009f, 6.906f, 4.016f)
                curveTo(6.832f, 4.021f, 6.755f, 4.047f, 6.673f, 4.079f)
                lineTo(6.857f, 4.544f)
                curveTo(6.893f, 4.53f, 6.916f, 4.522f, 6.931f, 4.518f)
                curveTo(6.946f, 4.513f, 6.947f, 4.514f, 6.94f, 4.515f)
                curveTo(6.935f, 4.515f, 6.929f, 4.515f, 6.921f, 4.515f)
                curveTo(6.912f, 4.514f, 6.904f, 4.512f, 6.896f, 4.51f)
                curveTo(6.889f, 4.508f, 6.884f, 4.506f, 6.883f, 4.505f)
                curveTo(6.882f, 4.505f, 6.882f, 4.505f, 6.888f, 4.508f)
                lineTo(7.1f, 4.055f)
                close()
                moveTo(7.144f, 4.062f)
                curveTo(7.131f, 4.062f, 7.122f, 4.061f, 7.116f, 4.06f)
                curveTo(7.111f, 4.06f, 7.109f, 4.059f, 7.109f, 4.059f)
                curveTo(7.109f, 4.059f, 7.109f, 4.059f, 7.109f, 4.059f)
                curveTo(7.11f, 4.059f, 7.11f, 4.06f, 7.11f, 4.059f)
                curveTo(7.109f, 4.059f, 7.108f, 4.059f, 7.1f, 4.055f)
                lineTo(6.888f, 4.508f)
                curveTo(6.905f, 4.516f, 6.939f, 4.532f, 6.987f, 4.544f)
                curveTo(7.034f, 4.556f, 7.085f, 4.562f, 7.144f, 4.562f)
                verticalLineTo(4.062f)
                close()
                moveTo(7.572f, 4.158f)
                curveTo(7.427f, 3.955f, 7.427f, 3.955f, 7.427f, 3.955f)
                curveTo(7.427f, 3.955f, 7.427f, 3.955f, 7.427f, 3.955f)
                curveTo(7.427f, 3.955f, 7.427f, 3.955f, 7.427f, 3.955f)
                curveTo(7.427f, 3.955f, 7.427f, 3.955f, 7.427f, 3.955f)
                curveTo(7.428f, 3.954f, 7.428f, 3.954f, 7.428f, 3.954f)
                curveTo(7.428f, 3.954f, 7.428f, 3.954f, 7.428f, 3.955f)
                curveTo(7.427f, 3.955f, 7.426f, 3.956f, 7.424f, 3.957f)
                curveTo(7.42f, 3.96f, 7.413f, 3.964f, 7.405f, 3.969f)
                curveTo(7.387f, 3.98f, 7.361f, 3.995f, 7.331f, 4.009f)
                curveTo(7.265f, 4.041f, 7.197f, 4.062f, 7.144f, 4.062f)
                verticalLineTo(4.562f)
                curveTo(7.305f, 4.562f, 7.452f, 4.506f, 7.546f, 4.461f)
                curveTo(7.596f, 4.437f, 7.637f, 4.413f, 7.666f, 4.395f)
                curveTo(7.681f, 4.386f, 7.693f, 4.379f, 7.701f, 4.373f)
                curveTo(7.706f, 4.37f, 7.709f, 4.368f, 7.712f, 4.366f)
                curveTo(7.713f, 4.365f, 7.715f, 4.364f, 7.716f, 4.363f)
                curveTo(7.716f, 4.363f, 7.716f, 4.363f, 7.717f, 4.362f)
                curveTo(7.717f, 4.362f, 7.717f, 4.362f, 7.717f, 4.362f)
                curveTo(7.717f, 4.362f, 7.717f, 4.362f, 7.718f, 4.362f)
                curveTo(7.718f, 4.362f, 7.718f, 4.362f, 7.718f, 4.362f)
                curveTo(7.718f, 4.362f, 7.718f, 4.362f, 7.572f, 4.158f)
                close()
                moveTo(7.86f, 4.062f)
                curveTo(7.87f, 4.062f, 7.869f, 4.064f, 7.855f, 4.058f)
                curveTo(7.842f, 4.052f, 7.826f, 4.043f, 7.808f, 4.03f)
                curveTo(7.79f, 4.018f, 7.775f, 4.005f, 7.764f, 3.996f)
                curveTo(7.759f, 3.991f, 7.755f, 3.987f, 7.753f, 3.985f)
                curveTo(7.751f, 3.984f, 7.751f, 3.983f, 7.751f, 3.983f)
                curveTo(7.75f, 3.983f, 7.751f, 3.983f, 7.751f, 3.983f)
                curveTo(7.751f, 3.983f, 7.751f, 3.983f, 7.751f, 3.984f)
                curveTo(7.751f, 3.984f, 7.751f, 3.984f, 7.751f, 3.984f)
                curveTo(7.751f, 3.984f, 7.751f, 3.984f, 7.751f, 3.984f)
                curveTo(7.751f, 3.984f, 7.751f, 3.984f, 7.751f, 3.984f)
                curveTo(7.752f, 3.984f, 7.752f, 3.984f, 7.572f, 4.158f)
                curveTo(7.393f, 4.333f, 7.393f, 4.333f, 7.393f, 4.333f)
                curveTo(7.393f, 4.333f, 7.393f, 4.333f, 7.393f, 4.333f)
                curveTo(7.393f, 4.333f, 7.393f, 4.333f, 7.393f, 4.333f)
                curveTo(7.393f, 4.333f, 7.394f, 4.333f, 7.394f, 4.333f)
                curveTo(7.394f, 4.334f, 7.394f, 4.334f, 7.395f, 4.334f)
                curveTo(7.395f, 4.335f, 7.396f, 4.336f, 7.397f, 4.337f)
                curveTo(7.399f, 4.339f, 7.402f, 4.342f, 7.405f, 4.345f)
                curveTo(7.412f, 4.351f, 7.421f, 4.359f, 7.431f, 4.369f)
                curveTo(7.453f, 4.388f, 7.483f, 4.414f, 7.52f, 4.44f)
                curveTo(7.584f, 4.484f, 7.71f, 4.562f, 7.86f, 4.562f)
                verticalLineTo(4.062f)
                close()
                moveTo(8f, 4.158f)
                curveTo(7.75f, 4.155f, 7.75f, 4.155f, 7.75f, 4.155f)
                curveTo(7.75f, 4.155f, 7.75f, 4.155f, 7.75f, 4.155f)
                curveTo(7.75f, 4.155f, 7.75f, 4.154f, 7.75f, 4.154f)
                curveTo(7.75f, 4.154f, 7.75f, 4.154f, 7.75f, 4.154f)
                curveTo(7.75f, 4.153f, 7.75f, 4.152f, 7.75f, 4.152f)
                curveTo(7.75f, 4.151f, 7.75f, 4.15f, 7.75f, 4.149f)
                curveTo(7.75f, 4.148f, 7.75f, 4.147f, 7.75f, 4.146f)
                curveTo(7.751f, 4.144f, 7.751f, 4.143f, 7.751f, 4.142f)
                curveTo(7.751f, 4.142f, 7.751f, 4.137f, 7.755f, 4.13f)
                curveTo(7.759f, 4.122f, 7.769f, 4.103f, 7.792f, 4.086f)
                curveTo(7.818f, 4.067f, 7.845f, 4.062f, 7.86f, 4.062f)
                verticalLineTo(4.562f)
                curveTo(7.944f, 4.562f, 8.022f, 4.537f, 8.088f, 4.489f)
                curveTo(8.15f, 4.444f, 8.187f, 4.387f, 8.208f, 4.34f)
                curveTo(8.23f, 4.294f, 8.24f, 4.252f, 8.244f, 4.223f)
                curveTo(8.247f, 4.207f, 8.248f, 4.194f, 8.249f, 4.184f)
                curveTo(8.249f, 4.179f, 8.25f, 4.175f, 8.25f, 4.171f)
                curveTo(8.25f, 4.169f, 8.25f, 4.167f, 8.25f, 4.166f)
                curveTo(8.25f, 4.165f, 8.25f, 4.164f, 8.25f, 4.163f)
                curveTo(8.25f, 4.163f, 8.25f, 4.163f, 8.25f, 4.162f)
                curveTo(8.25f, 4.162f, 8.25f, 4.162f, 8.25f, 4.162f)
                curveTo(8.25f, 4.162f, 8.25f, 4.162f, 8.25f, 4.162f)
                curveTo(8.25f, 4.162f, 8.25f, 4.162f, 8f, 4.158f)
                close()
                moveTo(7.75f, 3.65f)
                verticalLineTo(4.158f)
                horizontalLineTo(8.25f)
                verticalLineTo(3.65f)
                horizontalLineTo(7.75f)
                close()
                moveTo(8.016f, 3.4f)
                horizontalLineTo(8f)
                verticalLineTo(3.9f)
                horizontalLineTo(8.016f)
                verticalLineTo(3.4f)
                close()
                moveTo(7.766f, 3.65f)
                verticalLineTo(4.158f)
                horizontalLineTo(8.266f)
                verticalLineTo(3.65f)
                horizontalLineTo(7.766f)
                close()
                moveTo(8.016f, 4.158f)
                curveTo(7.766f, 4.162f, 7.766f, 4.162f, 7.766f, 4.162f)
                curveTo(7.766f, 4.162f, 7.766f, 4.162f, 7.766f, 4.162f)
                curveTo(7.766f, 4.162f, 7.766f, 4.162f, 7.766f, 4.162f)
                curveTo(7.766f, 4.163f, 7.766f, 4.163f, 7.766f, 4.163f)
                curveTo(7.766f, 4.164f, 7.766f, 4.165f, 7.766f, 4.166f)
                curveTo(7.766f, 4.167f, 7.766f, 4.169f, 7.766f, 4.171f)
                curveTo(7.766f, 4.175f, 7.766f, 4.179f, 7.767f, 4.184f)
                curveTo(7.767f, 4.194f, 7.769f, 4.207f, 7.771f, 4.223f)
                curveTo(7.776f, 4.252f, 7.786f, 4.294f, 7.807f, 4.34f)
                curveTo(7.828f, 4.387f, 7.865f, 4.444f, 7.928f, 4.489f)
                curveTo(7.993f, 4.537f, 8.072f, 4.562f, 8.156f, 4.562f)
                verticalLineTo(4.062f)
                curveTo(8.171f, 4.062f, 8.197f, 4.067f, 8.223f, 4.086f)
                curveTo(8.246f, 4.103f, 8.257f, 4.122f, 8.261f, 4.13f)
                curveTo(8.264f, 4.137f, 8.265f, 4.142f, 8.265f, 4.142f)
                curveTo(8.265f, 4.143f, 8.265f, 4.144f, 8.265f, 4.146f)
                curveTo(8.265f, 4.147f, 8.265f, 4.148f, 8.265f, 4.149f)
                curveTo(8.265f, 4.15f, 8.265f, 4.151f, 8.265f, 4.152f)
                curveTo(8.265f, 4.152f, 8.265f, 4.153f, 8.265f, 4.154f)
                curveTo(8.265f, 4.154f, 8.265f, 4.154f, 8.265f, 4.154f)
                curveTo(8.265f, 4.154f, 8.265f, 4.155f, 8.265f, 4.155f)
                curveTo(8.265f, 4.155f, 8.265f, 4.155f, 8.265f, 4.155f)
                curveTo(8.265f, 4.155f, 8.265f, 4.155f, 8.016f, 4.158f)
                close()
                moveTo(8.156f, 4.562f)
                curveTo(8.306f, 4.562f, 8.432f, 4.484f, 8.495f, 4.44f)
                curveTo(8.532f, 4.414f, 8.563f, 4.388f, 8.584f, 4.369f)
                curveTo(8.595f, 4.359f, 8.604f, 4.351f, 8.61f, 4.345f)
                curveTo(8.613f, 4.342f, 8.616f, 4.339f, 8.618f, 4.337f)
                curveTo(8.619f, 4.336f, 8.62f, 4.335f, 8.621f, 4.334f)
                curveTo(8.621f, 4.334f, 8.621f, 4.334f, 8.622f, 4.333f)
                curveTo(8.622f, 4.333f, 8.622f, 4.333f, 8.622f, 4.333f)
                curveTo(8.622f, 4.333f, 8.622f, 4.333f, 8.622f, 4.333f)
                curveTo(8.622f, 4.333f, 8.622f, 4.333f, 8.622f, 4.333f)
                curveTo(8.622f, 4.333f, 8.622f, 4.333f, 8.443f, 4.158f)
                curveTo(8.264f, 3.984f, 8.264f, 3.984f, 8.264f, 3.984f)
                curveTo(8.264f, 3.984f, 8.264f, 3.984f, 8.264f, 3.984f)
                curveTo(8.264f, 3.984f, 8.264f, 3.984f, 8.264f, 3.984f)
                curveTo(8.264f, 3.984f, 8.264f, 3.984f, 8.264f, 3.984f)
                curveTo(8.265f, 3.983f, 8.265f, 3.983f, 8.265f, 3.983f)
                curveTo(8.265f, 3.983f, 8.265f, 3.983f, 8.265f, 3.983f)
                curveTo(8.265f, 3.983f, 8.264f, 3.984f, 8.263f, 3.985f)
                curveTo(8.261f, 3.987f, 8.257f, 3.991f, 8.251f, 3.996f)
                curveTo(8.241f, 4.005f, 8.225f, 4.018f, 8.208f, 4.03f)
                curveTo(8.19f, 4.043f, 8.173f, 4.052f, 8.16f, 4.058f)
                curveTo(8.146f, 4.064f, 8.146f, 4.062f, 8.156f, 4.062f)
                verticalLineTo(4.562f)
                close()
                moveTo(8.443f, 4.158f)
                curveTo(8.298f, 4.362f, 8.298f, 4.362f, 8.298f, 4.362f)
                curveTo(8.298f, 4.362f, 8.298f, 4.362f, 8.298f, 4.362f)
                curveTo(8.298f, 4.362f, 8.298f, 4.362f, 8.298f, 4.362f)
                curveTo(8.298f, 4.362f, 8.299f, 4.362f, 8.299f, 4.362f)
                curveTo(8.299f, 4.363f, 8.299f, 4.363f, 8.3f, 4.363f)
                curveTo(8.301f, 4.364f, 8.302f, 4.365f, 8.303f, 4.366f)
                curveTo(8.306f, 4.368f, 8.31f, 4.37f, 8.314f, 4.373f)
                curveTo(8.323f, 4.379f, 8.335f, 4.386f, 8.349f, 4.395f)
                curveTo(8.379f, 4.413f, 8.42f, 4.437f, 8.469f, 4.461f)
                curveTo(8.564f, 4.506f, 8.711f, 4.562f, 8.872f, 4.562f)
                verticalLineTo(4.062f)
                curveTo(8.819f, 4.062f, 8.751f, 4.041f, 8.685f, 4.009f)
                curveTo(8.654f, 3.995f, 8.628f, 3.98f, 8.611f, 3.969f)
                curveTo(8.602f, 3.964f, 8.596f, 3.96f, 8.592f, 3.957f)
                curveTo(8.59f, 3.956f, 8.588f, 3.955f, 8.588f, 3.955f)
                curveTo(8.588f, 3.954f, 8.588f, 3.954f, 8.588f, 3.954f)
                curveTo(8.588f, 3.954f, 8.588f, 3.954f, 8.588f, 3.955f)
                curveTo(8.588f, 3.955f, 8.588f, 3.955f, 8.588f, 3.955f)
                curveTo(8.588f, 3.955f, 8.588f, 3.955f, 8.588f, 3.955f)
                curveTo(8.589f, 3.955f, 8.589f, 3.955f, 8.589f, 3.955f)
                curveTo(8.589f, 3.955f, 8.589f, 3.955f, 8.443f, 4.158f)
                close()
                moveTo(8.872f, 4.562f)
                curveTo(8.931f, 4.562f, 8.982f, 4.556f, 9.029f, 4.544f)
                curveTo(9.076f, 4.532f, 9.111f, 4.516f, 9.127f, 4.508f)
                lineTo(8.915f, 4.055f)
                curveTo(8.908f, 4.059f, 8.907f, 4.059f, 8.906f, 4.059f)
                curveTo(8.906f, 4.06f, 8.906f, 4.059f, 8.906f, 4.059f)
                curveTo(8.907f, 4.059f, 8.907f, 4.059f, 8.907f, 4.059f)
                curveTo(8.907f, 4.059f, 8.904f, 4.06f, 8.899f, 4.06f)
                curveTo(8.894f, 4.061f, 8.885f, 4.062f, 8.872f, 4.062f)
                verticalLineTo(4.562f)
                close()
                moveTo(9.127f, 4.508f)
                curveTo(9.133f, 4.505f, 9.134f, 4.505f, 9.133f, 4.505f)
                curveTo(9.131f, 4.506f, 9.126f, 4.508f, 9.119f, 4.51f)
                curveTo(9.112f, 4.512f, 9.103f, 4.514f, 9.095f, 4.515f)
                curveTo(9.087f, 4.515f, 9.08f, 4.515f, 9.076f, 4.515f)
                curveTo(9.068f, 4.514f, 9.069f, 4.513f, 9.085f, 4.518f)
                curveTo(9.1f, 4.522f, 9.123f, 4.53f, 9.158f, 4.544f)
                lineTo(9.343f, 4.079f)
                curveTo(9.26f, 4.047f, 9.183f, 4.021f, 9.109f, 4.016f)
                curveTo(9.011f, 4.009f, 8.945f, 4.041f, 8.915f, 4.055f)
                lineTo(9.127f, 4.508f)
                close()
                moveTo(9.158f, 4.544f)
                curveTo(9.157f, 4.543f, 9.186f, 4.558f, 9.235f, 4.629f)
                curveTo(9.28f, 4.695f, 9.327f, 4.791f, 9.37f, 4.912f)
                curveTo(9.455f, 5.155f, 9.513f, 5.475f, 9.513f, 5.806f)
                horizontalLineTo(10.013f)
                curveTo(10.013f, 5.421f, 9.946f, 5.046f, 9.841f, 4.747f)
                curveTo(9.789f, 4.597f, 9.724f, 4.46f, 9.649f, 4.348f)
                curveTo(9.576f, 4.241f, 9.476f, 4.132f, 9.343f, 4.079f)
                lineTo(9.158f, 4.544f)
                close()
                moveTo(9.513f, 5.806f)
                curveTo(9.513f, 5.927f, 9.452f, 6.13f, 9.33f, 6.397f)
                curveTo(9.212f, 6.653f, 9.052f, 6.935f, 8.89f, 7.201f)
                curveTo(8.728f, 7.465f, 8.566f, 7.708f, 8.444f, 7.885f)
                curveTo(8.383f, 7.973f, 8.332f, 8.045f, 8.297f, 8.094f)
                curveTo(8.279f, 8.119f, 8.265f, 8.138f, 8.256f, 8.151f)
                curveTo(8.251f, 8.157f, 8.247f, 8.162f, 8.245f, 8.165f)
                curveTo(8.244f, 8.167f, 8.243f, 8.168f, 8.243f, 8.169f)
                curveTo(8.242f, 8.169f, 8.242f, 8.17f, 8.242f, 8.17f)
                curveTo(8.242f, 8.17f, 8.242f, 8.17f, 8.242f, 8.17f)
                curveTo(8.242f, 8.17f, 8.242f, 8.17f, 8.242f, 8.17f)
                curveTo(8.242f, 8.17f, 8.242f, 8.17f, 8.443f, 8.318f)
                curveTo(8.645f, 8.466f, 8.645f, 8.466f, 8.645f, 8.466f)
                curveTo(8.645f, 8.466f, 8.645f, 8.466f, 8.645f, 8.466f)
                curveTo(8.645f, 8.466f, 8.645f, 8.466f, 8.645f, 8.466f)
                curveTo(8.645f, 8.465f, 8.645f, 8.465f, 8.646f, 8.465f)
                curveTo(8.646f, 8.464f, 8.648f, 8.462f, 8.649f, 8.46f)
                curveTo(8.652f, 8.457f, 8.655f, 8.452f, 8.66f, 8.445f)
                curveTo(8.67f, 8.431f, 8.685f, 8.411f, 8.703f, 8.385f)
                curveTo(8.74f, 8.334f, 8.792f, 8.259f, 8.855f, 8.168f)
                curveTo(8.981f, 7.987f, 9.148f, 7.736f, 9.316f, 7.462f)
                curveTo(9.484f, 7.189f, 9.654f, 6.888f, 9.784f, 6.606f)
                curveTo(9.909f, 6.334f, 10.013f, 6.044f, 10.013f, 5.806f)
                horizontalLineTo(9.513f)
                close()
                moveTo(8.202f, 8.385f)
                lineTo(8.272f, 8.637f)
                lineTo(8.754f, 8.504f)
                lineTo(8.684f, 8.251f)
                lineTo(8.202f, 8.385f)
                close()
                moveTo(8.513f, 8.571f)
                curveTo(8.667f, 8.767f, 8.667f, 8.767f, 8.667f, 8.767f)
                curveTo(8.667f, 8.767f, 8.667f, 8.767f, 8.667f, 8.767f)
                curveTo(8.668f, 8.767f, 8.668f, 8.767f, 8.668f, 8.767f)
                curveTo(8.668f, 8.767f, 8.669f, 8.766f, 8.669f, 8.766f)
                curveTo(8.67f, 8.765f, 8.671f, 8.764f, 8.673f, 8.763f)
                curveTo(8.676f, 8.76f, 8.681f, 8.757f, 8.686f, 8.752f)
                curveTo(8.698f, 8.743f, 8.714f, 8.729f, 8.734f, 8.712f)
                curveTo(8.775f, 8.678f, 8.834f, 8.627f, 8.904f, 8.562f)
                curveTo(9.045f, 8.432f, 9.236f, 8.244f, 9.439f, 8.008f)
                curveTo(9.841f, 7.54f, 10.302f, 6.868f, 10.49f, 6.081f)
                lineTo(10.004f, 5.965f)
                curveTo(9.842f, 6.642f, 9.437f, 7.243f, 9.06f, 7.682f)
                curveTo(8.872f, 7.901f, 8.695f, 8.075f, 8.566f, 8.194f)
                curveTo(8.501f, 8.254f, 8.448f, 8.3f, 8.412f, 8.33f)
                curveTo(8.394f, 8.345f, 8.38f, 8.356f, 8.371f, 8.364f)
                curveTo(8.367f, 8.368f, 8.363f, 8.37f, 8.361f, 8.372f)
                curveTo(8.36f, 8.373f, 8.359f, 8.373f, 8.359f, 8.374f)
                curveTo(8.359f, 8.374f, 8.359f, 8.374f, 8.359f, 8.374f)
                curveTo(8.359f, 8.374f, 8.359f, 8.374f, 8.359f, 8.374f)
                curveTo(8.359f, 8.374f, 8.359f, 8.374f, 8.359f, 8.374f)
                curveTo(8.359f, 8.374f, 8.359f, 8.374f, 8.513f, 8.571f)
                close()
                moveTo(10.49f, 6.081f)
                curveTo(10.685f, 5.264f, 10.429f, 4.585f, 10.135f, 4.122f)
                curveTo(9.988f, 3.89f, 9.83f, 3.708f, 9.708f, 3.585f)
                curveTo(9.647f, 3.522f, 9.595f, 3.474f, 9.557f, 3.441f)
                curveTo(9.538f, 3.425f, 9.523f, 3.412f, 9.512f, 3.403f)
                curveTo(9.507f, 3.398f, 9.502f, 3.395f, 9.499f, 3.392f)
                curveTo(9.497f, 3.391f, 9.496f, 3.389f, 9.495f, 3.389f)
                curveTo(9.494f, 3.388f, 9.494f, 3.388f, 9.493f, 3.388f)
                curveTo(9.493f, 3.387f, 9.493f, 3.387f, 9.493f, 3.387f)
                curveTo(9.493f, 3.387f, 9.493f, 3.387f, 9.493f, 3.387f)
                curveTo(9.493f, 3.387f, 9.492f, 3.387f, 9.339f, 3.584f)
                curveTo(9.186f, 3.782f, 9.186f, 3.782f, 9.186f, 3.782f)
                curveTo(9.186f, 3.782f, 9.185f, 3.782f, 9.185f, 3.782f)
                curveTo(9.185f, 3.781f, 9.185f, 3.781f, 9.185f, 3.781f)
                curveTo(9.185f, 3.781f, 9.185f, 3.781f, 9.185f, 3.781f)
                curveTo(9.185f, 3.782f, 9.186f, 3.782f, 9.187f, 3.782f)
                curveTo(9.188f, 3.784f, 9.191f, 3.786f, 9.194f, 3.789f)
                curveTo(9.201f, 3.795f, 9.213f, 3.804f, 9.227f, 3.817f)
                curveTo(9.257f, 3.843f, 9.3f, 3.883f, 9.352f, 3.935f)
                curveTo(9.455f, 4.04f, 9.589f, 4.194f, 9.713f, 4.389f)
                curveTo(9.96f, 4.779f, 10.158f, 5.32f, 10.004f, 5.965f)
                lineTo(10.49f, 6.081f)
                close()
                moveTo(9.361f, 3.335f)
                lineTo(9.28f, 3.328f)
                lineTo(9.236f, 3.826f)
                lineTo(9.317f, 3.833f)
                lineTo(9.361f, 3.335f)
                close()
                moveTo(9.008f, 3.2f)
                verticalLineTo(3.577f)
                horizontalLineTo(9.508f)
                verticalLineTo(3.2f)
                horizontalLineTo(9.008f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF8FC753)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(6.552f, 6.892f)
                curveTo(6.552f, 6.892f, 6.709f, 6.47f, 6.984f, 6.611f)
                curveTo(7.259f, 6.752f, 7.235f, 7.242f, 7.485f, 7.067f)
                curveTo(7.735f, 6.892f, 7.593f, 6.611f, 7.964f, 6.611f)
                curveTo(8.335f, 6.611f, 8.28f, 7.067f, 8.503f, 7.067f)
                curveTo(8.725f, 7.067f, 8.744f, 6.611f, 8.993f, 6.611f)
                curveTo(9.241f, 6.611f, 9.493f, 6.892f, 9.493f, 6.892f)
                lineTo(8.023f, 8.894f)
                lineTo(6.552f, 6.892f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFD018)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(7.947f, 1.015f)
                horizontalLineTo(8.047f)
                verticalLineTo(1.122f)
                horizontalLineTo(8.17f)
                verticalLineTo(1.222f)
                horizontalLineTo(8.047f)
                verticalLineTo(1.404f)
                curveTo(8.185f, 1.427f, 8.29f, 1.551f, 8.29f, 1.7f)
                curveTo(8.29f, 1.866f, 8.16f, 2f, 8f, 2f)
                curveTo(7.84f, 2f, 7.71f, 1.866f, 7.71f, 1.7f)
                curveTo(7.71f, 1.553f, 7.812f, 1.431f, 7.947f, 1.405f)
                verticalLineTo(1.222f)
                horizontalLineTo(7.834f)
                verticalLineTo(1.122f)
                horizontalLineTo(7.947f)
                verticalLineTo(1.015f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFE31D1C)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(6.874f, 2.583f)
                curveTo(6.734f, 2.583f, 6.438f, 2.765f, 6.438f, 2.765f)
                lineTo(6.668f, 3.385f)
                lineTo(8.052f, 3.322f)
                lineTo(9.437f, 3.385f)
                lineTo(9.666f, 2.765f)
                curveTo(9.666f, 2.765f, 9.371f, 2.583f, 9.231f, 2.583f)
                curveTo(9.169f, 2.583f, 9.162f, 2.539f, 9.153f, 2.49f)
                curveTo(9.142f, 2.426f, 9.129f, 2.355f, 9.001f, 2.355f)
                curveTo(8.91f, 2.355f, 8.846f, 2.373f, 8.794f, 2.388f)
                curveTo(8.716f, 2.41f, 8.665f, 2.425f, 8.592f, 2.355f)
                curveTo(8.589f, 2.352f, 8.586f, 2.349f, 8.583f, 2.346f)
                curveTo(8.465f, 2.232f, 8.342f, 2.114f, 8.143f, 2.114f)
                curveTo(8.104f, 2.114f, 8.074f, 2.16f, 8.052f, 2.233f)
                curveTo(8.03f, 2.16f, 8.001f, 2.114f, 7.961f, 2.114f)
                curveTo(7.762f, 2.114f, 7.64f, 2.232f, 7.522f, 2.346f)
                curveTo(7.519f, 2.349f, 7.515f, 2.352f, 7.512f, 2.355f)
                curveTo(7.439f, 2.425f, 7.389f, 2.41f, 7.31f, 2.388f)
                curveTo(7.258f, 2.373f, 7.194f, 2.355f, 7.104f, 2.355f)
                curveTo(6.975f, 2.355f, 6.963f, 2.426f, 6.952f, 2.49f)
                curveTo(6.943f, 2.539f, 6.935f, 2.583f, 6.874f, 2.583f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFD018)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(7.5f, 2f)
                curveTo(7.5f, 2f, 7.833f, 1.759f, 8f, 1.759f)
                curveTo(8.167f, 1.759f, 8.5f, 2f, 8.5f, 2f)
                verticalLineTo(4f)
                horizontalLineTo(7.5f)
                verticalLineTo(2f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFD018)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(7.804f, 1.784f)
                lineTo(7.707f, 1.818f)
                curveTo(7.45f, 1.907f, 7.228f, 1.936f, 7.04f, 1.907f)
                curveTo(6.653f, 1.848f, 6.149f, 2.049f, 6.212f, 2.344f)
                curveTo(6.24f, 2.473f, 6.32f, 2.717f, 6.405f, 2.923f)
                curveTo(6.521f, 3.21f, 6.603f, 3.355f, 6.698f, 3.355f)
                curveTo(6.711f, 3.355f, 6.841f, 3.362f, 6.884f, 3.364f)
                curveTo(6.892f, 3.365f, 6.897f, 3.365f, 6.898f, 3.365f)
                curveTo(7.038f, 3.372f, 7.162f, 3.376f, 7.281f, 3.375f)
                curveTo(7.626f, 3.374f, 7.839f, 3.34f, 7.915f, 3.237f)
                lineTo(7.938f, 3.206f)
                lineTo(7.927f, 3.17f)
                curveTo(7.837f, 2.858f, 7.795f, 2.432f, 7.803f, 1.89f)
                lineTo(7.804f, 1.784f)
                close()
                moveTo(6.354f, 2.311f)
                curveTo(6.323f, 2.167f, 6.717f, 2.009f, 7.018f, 2.056f)
                curveTo(7.206f, 2.085f, 7.419f, 2.063f, 7.657f, 1.991f)
                curveTo(7.655f, 2.473f, 7.695f, 2.864f, 7.775f, 3.165f)
                curveTo(7.706f, 3.201f, 7.525f, 3.224f, 7.28f, 3.225f)
                curveTo(7.164f, 3.226f, 7.043f, 3.222f, 6.905f, 3.215f)
                curveTo(6.906f, 3.215f, 6.762f, 3.207f, 6.713f, 3.205f)
                curveTo(6.712f, 3.204f, 6.71f, 3.202f, 6.707f, 3.199f)
                curveTo(6.694f, 3.184f, 6.678f, 3.16f, 6.66f, 3.127f)
                curveTo(6.624f, 3.064f, 6.582f, 2.973f, 6.538f, 2.865f)
                curveTo(6.457f, 2.666f, 6.379f, 2.43f, 6.354f, 2.311f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFD018)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(8.227f, 1.784f)
                lineTo(8.325f, 1.818f)
                curveTo(8.581f, 1.907f, 8.804f, 1.936f, 8.992f, 1.907f)
                curveTo(9.378f, 1.848f, 9.883f, 2.049f, 9.82f, 2.344f)
                curveTo(9.792f, 2.473f, 9.711f, 2.717f, 9.627f, 2.923f)
                curveTo(9.51f, 3.21f, 9.429f, 3.355f, 9.333f, 3.355f)
                curveTo(9.321f, 3.355f, 9.191f, 3.362f, 9.148f, 3.364f)
                curveTo(9.14f, 3.365f, 9.135f, 3.365f, 9.134f, 3.365f)
                curveTo(8.993f, 3.372f, 8.87f, 3.376f, 8.75f, 3.375f)
                curveTo(8.406f, 3.374f, 8.192f, 3.34f, 8.116f, 3.237f)
                lineTo(8.094f, 3.206f)
                lineTo(8.104f, 3.17f)
                curveTo(8.195f, 2.858f, 8.237f, 2.432f, 8.229f, 1.89f)
                lineTo(8.227f, 1.784f)
                close()
                moveTo(9.678f, 2.311f)
                curveTo(9.709f, 2.167f, 9.314f, 2.009f, 9.013f, 2.056f)
                curveTo(8.825f, 2.085f, 8.613f, 2.063f, 8.375f, 1.991f)
                curveTo(8.376f, 2.473f, 8.337f, 2.864f, 8.257f, 3.165f)
                curveTo(8.325f, 3.201f, 8.506f, 3.224f, 8.751f, 3.225f)
                curveTo(8.867f, 3.226f, 8.989f, 3.222f, 9.127f, 3.215f)
                curveTo(9.126f, 3.215f, 9.269f, 3.207f, 9.318f, 3.205f)
                curveTo(9.32f, 3.204f, 9.322f, 3.202f, 9.324f, 3.199f)
                curveTo(9.337f, 3.184f, 9.353f, 3.16f, 9.371f, 3.127f)
                curveTo(9.407f, 3.064f, 9.449f, 2.973f, 9.493f, 2.865f)
                curveTo(9.574f, 2.666f, 9.652f, 2.43f, 9.678f, 2.311f)
                close()
            }
            path(fill = SolidColor(Color.White)) {
                moveTo(3.979f, 10.16f)
                lineTo(3.608f, 9.231f)
                curveTo(5.139f, 8.621f, 6.603f, 8.314f, 8f, 8.314f)
                curveTo(9.38f, 8.314f, 10.682f, 8.503f, 11.905f, 8.881f)
                lineTo(11.61f, 9.837f)
                curveTo(10.484f, 9.489f, 9.281f, 9.314f, 8f, 9.314f)
                curveTo(6.736f, 9.314f, 5.396f, 9.595f, 3.979f, 10.16f)
                close()
            }
            path(fill = SolidColor(Color(0xFF272727))) {
                moveTo(6.887f, 8.942f)
                lineTo(6.917f, 8.694f)
                curveTo(7.455f, 8.76f, 7.813f, 8.793f, 7.994f, 8.793f)
                curveTo(8.267f, 8.805f, 8.592f, 8.786f, 8.968f, 8.734f)
                lineTo(9.003f, 8.981f)
                curveTo(8.612f, 9.035f, 8.272f, 9.056f, 7.989f, 9.043f)
                curveTo(7.8f, 9.043f, 7.434f, 9.009f, 6.887f, 8.942f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF006923)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(5.162f, 4f)
                curveTo(5.162f, 4f, 3.771f, 5.255f, 4.045f, 6.483f)
                curveTo(4.357f, 8.352f, 6.229f, 9.004f, 6.229f, 9.004f)
                lineTo(7.221f, 8.653f)
                curveTo(7.221f, 8.653f, 5.321f, 7.564f, 5.321f, 6.483f)
                curveTo(5.321f, 5.402f, 5.606f, 4f, 5.606f, 4f)
                horizontalLineTo(5.162f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF009933)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(11.059f, 4f)
                curveTo(11.059f, 4f, 12.45f, 5.255f, 12.176f, 6.483f)
                curveTo(11.864f, 8.352f, 9.992f, 9.004f, 9.992f, 9.004f)
                lineTo(9f, 8.653f)
                curveTo(9f, 8.653f, 10.9f, 7.564f, 10.9f, 6.483f)
                curveTo(10.9f, 5.402f, 10.616f, 4f, 10.616f, 4f)
                horizontalLineTo(11.059f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun SanMarinoPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Small.SanMarino,
            contentDescription = "San Marino Flag"
        )
    }
}
